import type { SVGProps } from 'react';

export function BUSINESSRECHARGE(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7143 2.26299C16.7143 1.72334 16.2823 1.28564 15.7497 1.28564H2.25038C1.71776 1.28564 1.28577 1.72334 1.28577 2.26299V4.21768H16.7126V2.26299H16.7143Z"
        fill="#D3D3D3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7143 6H1.28577V15.0716C1.28577 15.6239 1.73348 16.0716 2.28577 16.0716H15.7143C16.2666 16.0716 16.7143 15.6239 16.7143 15.0716V6ZM3.23145 11.0716C2.87641 11.0716 2.58859 11.3594 2.58859 11.7145C2.58859 12.0695 2.8764 12.3573 3.23144 12.3573H6.74573C7.10077 12.3573 7.38859 12.0695 7.38859 11.7145C7.38859 11.3594 7.10077 11.0716 6.74573 11.0716H3.23145ZM2.58859 9.00021C2.58859 8.64517 2.87641 8.35735 3.23145 8.35735H6.74573C7.10077 8.35735 7.38859 8.64517 7.38859 9.00021C7.38859 9.35525 7.10077 9.64307 6.74573 9.64307H3.23144C2.8764 9.64307 2.58859 9.35525 2.58859 9.00021ZM10.9286 8.35735C10.5736 8.35735 10.2858 8.64517 10.2858 9.00021C10.2858 9.35525 10.5736 9.64307 10.9286 9.64307H12.2143C12.5694 9.64307 12.8572 9.35525 12.8572 9.00021C12.8572 8.64517 12.5694 8.35735 12.2143 8.35735H10.9286Z"
        fill="currentColor"
      />
    </svg>
  );
}
